export const contextKey = 'abort';

export const abort = (executionContext) => {
	const abortContext = executionContext[contextKey];
	if (abortContext && abortContext.controller) {
		abortContext.controller.abort();
	}
};

export const getAbortSignal = (executionContext) => {
	const abortContext = executionContext[contextKey];
	if (abortContext && abortContext.controller) {
		return abortContext.controller.signal;
	} else {
		return null;
	}
};

export const getWrapper = (nextAction) => {
	return (fnArgs, executionContext) => {
		executionContext[contextKey].controller = new AbortController();

		const nextActionPromise = (async () =>
			nextAction(fnArgs, executionContext))();

		nextActionPromise.cancel = () => abort(executionContext);

		return nextActionPromise;
	};
};

getWrapper.contextKey = contextKey;
